import { render, staticRenderFns } from "./PlayVideo.vue?vue&type=template&id=7b7bc004&scoped=true"
import script from "./PlayVideo.vue?vue&type=script&lang=js"
export * from "./PlayVideo.vue?vue&type=script&lang=js"
import style0 from "./PlayVideo.vue?vue&type=style&index=0&id=7b7bc004&prod&scoped=true&lang=less"
import style1 from "./PlayVideo.vue?vue&type=style&index=1&id=7b7bc004&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7bc004",
  null
  
)

export default component.exports